module.exports = "/static/assets/edabaf21efbdb886455e43629ab5b2f5.png";